module.exports = __webpack_public_path__ + "static/media/carro_5.a8178362.png";